import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import isEqual from "react-fast-compare";
import Image from "antd/lib/image";
import Popover from "antd/lib/popover";
import Tooltip from "antd/lib/tooltip";
import Modal from "antd/lib/modal";
import Profile from "../../../../assets/Profile_Pic.svg";
import fx from "../../../../assets/WidgetMaker/FX.svg";
import InfoIcon from "../../../../assets/Info_Icon.svg";
import InfoIconYellow from "../../../../assets/Info_Icon_Yellow.svg";
import BoostedPostIcon from "../../../../assets/boosted_post_icon.svg";
import AdsPostIcon from "../../../../assets/ads_post_icon.svg";
import defaultImg from "../../../../assets/WidgetMaker/Brocken_Image.svg";
import placeHolderImg from "../../../../assets/placeholder_img.png";
import Default_Brand from "../../../../assets/brandLogos/Default_Brand.svg";
import userFollowers from "../../../../assets/FollowersBlue.svg";
import ClockIcon from "../../../../assets/Clock.svg";
import verified from "../../../../assets/verified.svg";
import somethingWentWrong from "../../../../assets/No_Data_Found.svg";
import { getClass, kFormatter } from "../../../../redux/constants";
import { SocialMedialogo } from "../../../layout/DeepDive/DeepDivetab/SocialMediaPlatforms";
import moment from "moment";
import Carousel from "../../../WidgetMaker/Carousel";
import PostCardFooter from "../../../WidgetMaker/PostCardFooter";
import VideoPreview from "../../../WidgetMaker/VideoPreview";
import { useDispatch } from "react-redux";
import { setHighChartClickedNetworkNode } from "../../../../redux/actions/HighChart";
import FollowersBlue from "../../../../assets/FollowersBlue.svg";
import FollowingBlue from "../../../../assets/deepDive/FollowingBlue.svg";
import {
  postCardUserBrandCommentId,
  postCardUserbrandPrivateMessagesId,
} from "../../../../redux/constants/enums";

const NetworkNodeModal = ({
  data,
  modalData,
  PdfDownloadStatus,
  PptGeneratingStatus,
  isPreviewState,
  setIsModalOpen,
  isModalOpen,
  setIsModalData,
  isModalLoader,
  setIsModalLoader,
  isVisNetworkGraph,
}) => {
  const dispatch = useDispatch();
  const authParams = useSelector((state) => state.Authentication.authParams);
  const isshowSideBar = useSelector((state) => state.WidgetMaker.isshowSideBar);

  const [visible, setVisible] = useState(false);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [videoPreview, setVideoPreview] = useState();
  const [isValidUrlFlag, setIsValidUrlFlag] = useState(null);

  const [isModalReadMore, setIsModalReadMore] = useState({
    value: false,
    id: null,
  });
  const [isImage, setIsImage] = useState(false);

  // console.log("modalData ===>", modalData);
  // console.log("modalData", modalData?.is_main_node);
  const handleCancel = () => {
    if (!isVisNetworkGraph) {
      dispatch(
        setHighChartClickedNetworkNode({ data: null, flag: false, id: null })
      );
    } else {
      setIsImage(false);
      setIsModalOpen(false);
      setIsModalData(null);
      setIsModalReadMore({ value: false, id: null });
    }
  };
  const getDefautBrandImg = (e) => {
    return (e.target.src = Default_Brand);
  };
  const onImageError = (e) => {
    if (e?.type === "error") {
      setIsImage(true);
    } else {
      setIsImage(false);
    }
    return (e.target.src = defaultImg);
  };
  useEffect(() => {
    setTimeout(() => {
      typeof setIsModalLoader === "function" && setIsModalLoader(false);
    }, 300);
  }, [isModalLoader]);

  const isScontentLinkExpire = (mediaUrl, channelType) => {
    let isExpired = false;
    try {
      if (
        mediaUrl &&
        mediaUrl.indexOf("s3.amazonaws") == -1 &&
        mediaUrl.indexOf("images.locobuzz.com") == -1
      ) {
        const tokens = mediaUrl.split("&");
        const HexDecimalCode = tokens.filter((x) => x.includes("oe="));
        if (
          HexDecimalCode != null &&
          HexDecimalCode.length > 0 &&
          HexDecimalCode[0].startsWith("oe=")
        ) {
          let DecimalEpoch = 0;
          if (HexDecimalCode.length > 0) {
            const HexDecimalTime = HexDecimalCode[0].replace("oe=", "");
            DecimalEpoch = parseInt(HexDecimalTime, 16);
          }
          // DateTimeOffset.Now.ToUnixTimeSeconds()
          if (moment().unix() > DecimalEpoch && DecimalEpoch > 0) {
            isExpired = true;
          }
        }
      }
    } catch (exception) {
      return false;
    }

    return isExpired;
  };

  const handleVideoPreview = (imgUrl) => {
    setIsVideoModalOpen(true);
    setVideoPreview(imgUrl?.MediaUrl);

    let isValidUrlFlag = isScontentLinkExpire(imgUrl?.MediaUrl, 1);
    setIsValidUrlFlag(isValidUrlFlag);
  };

  return (
    <Modal
      title={
        <div className="text_heading-Slab font-size16 font-weight500">
          Card Details
        </div>
      }
      footer={null}
      visible={isModalOpen}
      onOk={handleCancel}
      onCancel={handleCancel}
      width={675}
      style={{ top: "2rem" }}
      className={`postCard_dtails ${
        authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
      }`}
    >
      {modalData ? (
        isModalLoader ? (
          <div className="loader" style={{ height: "45rem" }}>
            <div className="lds-ring">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        ) : (
          <>
            {modalData?.is_main_node === 0 ? (
              <>
                <div className="row mr-0 pl-15 pr-15">
                  <div className={"col-12 col-md-12 pr-0"}>
                    <div className="card cardList border-0 text-left mb-15">
                      <div
                        className="cardList-head pb-0 p-15 mt-0 card-head text_heading d-flex align-items-top"
                        style={{ height: "auto" }}
                      >
                        <div
                          className="position-relative mr-15 d-flex align-items-center"
                          style={{ width: "3.5rem", height: "3.5rem" }}
                        >
                          <Image
                            src={
                              modalData?.ProfilePicture === 0 ||
                              modalData?.ProfilePicture === "" ||
                              !modalData?.ProfilePicture
                                ? Profile
                                : modalData?.ProfilePicture
                            }
                            fallback={Profile}
                            preview={false}
                            alt="Profile Images"
                            className="profileImg mr-0 cursor-pointer"
                            style={{ width: "3.5rem" }}
                          />
                          <div
                            className="position-absolute"
                            // style={{
                            //   right: "-1rem",
                            //   top: "0",
                            //   width: "2rem",
                            // }}
                            style={{ right: "-0.8rem", top: "-0.4rem" }}
                          >
                            <img
                              src={
                                modalData?.ChannelGroupID === 0
                                  ? Default_Brand
                                  : SocialMedialogo?.[modalData?.ChannelGroupID]
                                  ? SocialMedialogo?.[modalData?.ChannelGroupID]
                                  : Default_Brand
                              }
                              style={{
                                width: "1.6rem",
                                maxHeight: "2rem",
                                verticalAlign: "top",
                              }}
                              alt="channel icon"
                            />
                          </div>
                        </div>
                        <div style={{ width: "calc(100% - 11.4rem)" }}>
                          <div
                            className="profileName line-height-normal d-flex align-items-center"
                            //style={{ maxWidth: "calc(100% - 6.5rem)" }}
                          >
                            <Tooltip title={modalData?.AuthorName}>
                              <span className="text-ellipsis">
                                {modalData?.AuthorName}
                              </span>
                            </Tooltip>

                            {modalData?.AuthorIsVerified !== "NA" &&
                            modalData?.AuthorIsVerified &&
                            modalData?.AuthorIsVerified > 0 ? (
                              <img
                                src={verified}
                                alt="verified"
                                className="profileImg ml-1"
                                style={{ width: "1.5rem" }}
                              />
                            ) : (
                              ""
                            )}
                          </div>

                          <div
                            className="screenName"
                            //style={{ maxWidth: "50%" }}
                          >
                            {modalData?.AuthorScreenName ? "(" : ""}
                            {modalData?.AuthorScreenName}
                            {modalData?.AuthorScreenName ? ")" : ""}
                          </div>
                        </div>
                        {/* Hided the sentiment tag, because its not updated frequently */}
                        {/* <div
                          className={`sentimentType ${
                            modalData?.SentimentType === "1"
                              ? "positive"
                              : modalData?.SentimentType === "2"
                              ? "negative"
                              : "neutral"
                          }`}
                        >
                          {modalData?.UserSentiment === "1"
                            ? "Positive"
                            : modalData?.UserSentiment === "2"
                            ? "Negative"
                            : "Neutral"}
                        </div> */}
                      </div>
                      <div
                        className={`card-body p-0 border-0 mt-0 ${
                          !modalData?.AuthorBio
                            ? "d-flex justify-content-center align-items-center"
                            : ""
                        }`}
                      >
                        <div
                          className="cardList__body-description fontSize-12 pl-15 pr-15"
                          style={{
                            minHeight: !modalData?.AuthorBio ? "inherit" : "",
                          }}
                        >
                          {modalData?.AuthorBio ? (
                            <div className="text_regular font-weight500 w-100 mt-1">
                              Bio
                            </div>
                          ) : (
                            ""
                          )}

                          {modalData?.AuthorBio ? (
                            <div className="text_regular break-word w-100">
                              <a
                                className={
                                  modalData?.AuthorURL &&
                                  modalData?.AuthorURL !== "NA"
                                    ? ""
                                    : "pointer-events1 cursor-default"
                                }
                                href={
                                  modalData?.AuthorURL &&
                                  modalData?.AuthorURL !== "NA"
                                    ? modalData?.AuthorURL
                                    : ""
                                }
                                target="_blank"
                                rel="noreferrer"
                              >
                                {modalData?.AuthorBio}
                              </a>
                            </div>
                          ) : (
                            <div className="text-grayLight fontSize-14 d-flex justify-content-center align-items-center pt-15 pb-15 w-100">
                              Bio not found
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="pl-15 pr-15 mt-1 mb-15 d-flex align-items-center flex-wrap">
                        <span className="mr-15 d-flex align-items-center flex-wrap">
                          <img
                            src={FollowersBlue}
                            className="cardList__footer-label"
                            alt="Followers"
                          />
                          <span className="text-grayLight ml-1 mr-1 fontSize-12">
                            Followers
                          </span>
                          <Tooltip
                            title={modalData?.Followers?.toLocaleString()}
                          >
                            <span className="cardList__footer-count font-weight600 blue-text fontSize-12 cursor-pointer">
                              {kFormatter(modalData?.Followers)}
                            </span>
                          </Tooltip>
                        </span>
                        <span className="mr-15 d-flex align-items-center flex-wrap">
                          <img
                            src={FollowingBlue}
                            className="cardList__footer-label"
                            alt="FollowingBlue"
                          />
                          <span className="text-grayLight ml-1 mr-1 fontSize-12">
                            Following
                          </span>
                          <Tooltip
                            title={modalData?.Following?.toLocaleString()}
                          >
                            <span className="cardList__footer-count font-weight600 blue-text fontSize-12 cursor-pointer">
                              {kFormatter(modalData?.Following)}
                            </span>
                          </Tooltip>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="card cardList postCardItem text-left">
                  <div
                    className={`cardList-head card-head text_heading d-flex justify-content-between p-15 ${
                      authParams?.screen_id === "000-000-560"
                        ? ""
                        : " pt-10 pb-0"
                    } mt-0 align-items-top mb-2px ${
                      postCardUserbrandPrivateMessagesId?.includes(
                        modalData?.channel_type
                      )
                        ? getClass(authParams, "message")
                        : modalData?.PlatformID == 1 &&
                          modalData?.ParentSocialID !== "NA" &&
                          modalData?.ParentSocialID != 0 &&
                          modalData?.ParentSocialID !== ""
                        ? getClass(authParams, "comment")
                        : postCardUserBrandCommentId?.includes(
                            modalData?.channel_type
                          ) && modalData?.PlatformID != 1
                        ? getClass(authParams, "comment")
                        : getClass(authParams, "post")
                    }`}
                  >
                    <div
                      className="d-flex align-items-center"
                      style={{ width: "60%" }}
                    >
                      {modalData?.brand_logo &&
                      modalData?.BrandFriendlyName &&
                      modalData?.BrandFriendlyName !== "NA" &&
                      modalData?.BrandFriendlyName !== "" ? (
                        <Popover
                          placement="leftBottom"
                          title={null}
                          content={
                            <div
                              style={{
                                maxWidth: "25rem",
                                maxHeight: "20rem",
                                overflow: "auto",
                              }}
                              className="text_regular fontSize-12 p-10"
                            >
                              {modalData?.BrandFriendlyName}
                            </div>
                          }
                          overlayClassName={
                            authParams?.theme_type === "1"
                              ? "darkTheme"
                              : "lightTheme"
                          }
                        >
                          <Image
                            src={
                              modalData?.brand_logo
                                ? modalData?.brand_logo
                                : Default_Brand
                            }
                            fallback={Default_Brand}
                            onError={getDefautBrandImg}
                            preview={false}
                            alt="Brand logo"
                            className="profileImg ml-1 cursor-pointer"
                            style={{
                              width: "3.5rem",
                              height: "3.5rem",
                              // marginTop: "-0.5rem",
                            }}
                            // crossOrigin="anonymous"
                          />
                        </Popover>
                      ) : modalData?.BrandFriendlyName &&
                        modalData?.BrandFriendlyName !== "NA" &&
                        modalData?.BrandFriendlyName !== "" ? (
                        <Popover
                          placement="leftBottom"
                          title={null}
                          content={
                            <div
                              style={{
                                maxWidth: "25rem",
                                maxHeight: "20rem",
                                overflow: "auto",
                              }}
                              className="text_regular fontSize-12 p-10"
                            >
                              {modalData?.BrandFriendlyName}
                            </div>
                          }
                          overlayClassName={
                            authParams?.theme_type === "1"
                              ? "darkTheme"
                              : "lightTheme"
                          }
                        >
                          <Image
                            src={
                              modalData?.brand_logo
                                ? modalData?.brand_logo
                                : Default_Brand
                            }
                            fallback={Default_Brand}
                            preview={false}
                            alt="Brand logo"
                            className="profileImg ml-1 cursor-pointer"
                            style={{
                              width: "3.5rem",
                              height: "3.5rem",
                              // marginTop: "-0.5rem",
                            }}
                            // crossOrigin="anonymous"
                          />
                        </Popover>
                      ) : (
                        <Image
                          src={
                            modalData?.brand_logo
                              ? modalData?.brand_logo
                              : Default_Brand
                          }
                          fallback={Default_Brand}
                          preview={false}
                          alt="Brand logo"
                          className="profileImg ml-1 cursor-pointer"
                          style={{
                            width: "3.5rem",
                            height: "3.5rem",
                            // marginTop: "-0.5rem",
                          }}
                          // crossOrigin="anonymous"
                        />
                      )}

                      <div
                        className="position-relative mr-15 d-flex align-items-center"
                        style={{ width: "3.5rem" }}
                      >
                        {!PdfDownloadStatus && !PptGeneratingStatus ? (
                          <Popover
                            placement="leftBottom"
                            title={null}
                            content={
                              modalData?.AuthorBio &&
                              modalData?.AuthorBio !== "NA" &&
                              modalData?.AuthorBio !== "" && (
                                <div
                                  style={{
                                    maxWidth: "25rem",
                                    maxHeight: "20rem",
                                    overflow: "auto",
                                  }}
                                  className="text_regular fontSize-12 p-15 custom_scroll1"
                                >
                                  {modalData?.AuthorBio}
                                </div>
                              )
                            }
                            overlayClassName={
                              authParams?.theme_type === "1"
                                ? "darkTheme"
                                : "lightTheme"
                            }
                          >
                            <Image
                              src={
                                modalData?.ProfilePicture === 0 ||
                                modalData?.ProfilePicture === "" ||
                                !modalData?.ProfilePicture
                                  ? Profile
                                  : modalData?.ProfilePicture
                              }
                              fallback={Profile}
                              preview={false}
                              alt="Profile Images"
                              className="profileImg ml-1 cursor-pointer"
                              style={{ width: "3.5rem", height: "3.5rem" }}
                              crossOrigin="anonymous"
                            />
                          </Popover>
                        ) : (
                          <Image
                            src={
                              PdfDownloadStatus || PptGeneratingStatus
                                ? modalData?.ProfilePicture === 0 ||
                                  modalData?.ProfilePicture === "" ||
                                  !modalData?.ProfilePicture
                                  ? Profile
                                  : modalData?.ProfilePicture
                                : Profile
                            }
                            fallback={Profile}
                            preview={false}
                            alt="Profile Images"
                            className="profileImg ml-1 cursor-pointer"
                            style={{ width: "3.5rem", height: "3.5rem" }}
                            crossOrigin="anonymous"
                          />
                        )}
                        <div
                          className="position-absolute"
                          // style={{ right: "-1rem", top: "0" }}
                          style={{ right: "-0.8rem", top: "-0.4rem" }}
                        >
                          <Image
                            src={
                              modalData?.PlatformID === 0
                                ? Default_Brand
                                : SocialMedialogo?.[modalData?.PlatformID]
                                ? SocialMedialogo?.[modalData?.PlatformID]
                                : Default_Brand
                            }
                            alt="Channel"
                            preview={false}
                            fallback={Default_Brand}
                            style={{
                              width: "1.6rem",
                              maxHeight: "2rem",
                              verticalAlign: "top",
                            }}
                          />
                        </div>
                      </div>
                      <div style={{ width: "calc(100% - 6rem)" }}>
                        <div className="d-flex flex-wrap align-items-center">
                          <Tooltip title={modalData?.AuthorName}>
                            <div className="profileName text-ellipsis line-height-normal">
                              {modalData?.AuthorName}
                            </div>
                          </Tooltip>
                          {modalData?.AuthorIsVerified !== "NA" &&
                          modalData?.AuthorIsVerified &&
                          modalData?.AuthorIsVerified > 0 ? (
                            <img
                              src={verified}
                              alt="verified"
                              className="profileImg ml-1"
                              style={{ height: "1.6rem" }}
                            />
                          ) : (
                            ""
                          )}
                          {modalData?.isPromoted === 1 ? (
                            <Tooltip title="Boosted post">
                              <img
                                alt="Boosted Post Icon"
                                src={BoostedPostIcon}
                                className="mr-0"
                                style={{
                                  width: "2rem",
                                  height: "2rem",
                                }}
                              />
                            </Tooltip>
                          ) : modalData?.isPromoted === 2 ||
                            modalData?.isPromoted === 5 ? (
                            <Tooltip
                              title={
                                modalData?.isPromoted === 5
                                  ? "Dark Ad Post"
                                  : "Ad Post"
                              }
                            >
                              <img
                                alt="Ad Post Icon"
                                src={AdsPostIcon}
                                className="mr-0"
                                style={{
                                  width: "2rem",
                                  height: "2rem",
                                }}
                              />
                            </Tooltip>
                          ) : (
                            ""
                          )}
                        </div>
                        {modalData?.AuthorScreenName ? (
                          <div
                            className="screenName text-grayLight text-ellipsis w-100"
                            //style={{ width: "90%" }}
                          >
                            <Tooltip title={modalData?.AuthorScreenName}>
                              {modalData?.AuthorScreenName}
                            </Tooltip>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <span
                      className="font-size12 align-items-center d-flex"
                      style={{ maxWidth: "40%" }}
                    >
                      <Tooltip
                        title={
                          <div>
                            Created Date : <br /> {modalData?.CreatedDate}
                          </div>
                        }
                      >
                        <img
                          src={ClockIcon}
                          className="cardList__footer-label"
                          alt="ClockIcon"
                        />
                        <span className="cardList__footer-count text-grayLight">
                          {/* {modalData?.CreatedDate} */}
                          {moment(modalData?.CreatedDate)?.format(
                            "DD MMM YYYY"
                          )}
                        </span>
                      </Tooltip>
                    </span>
                  </div>
                  <div
                    className="card-body p-0 custom_scroll1"
                    style={{
                      maxHeight: "calc(100vh - 27.2rem)",
                      overflow: "auto",
                    }}
                  >
                    {modalData?.PlatformID === 1 && (
                      <div
                        className={`${
                          PdfDownloadStatus ? "mb-5" : "mb-15"
                        }  pl-15 d-flex pr-15`}
                      >
                        <img
                          src={userFollowers}
                          className="cardList__footer-label mr-1"
                          alt="userFollowers"
                        />
                        <span className="text-grayLight ml-1">Followers</span>
                        <Tooltip title={modalData?.Followers?.toLocaleString()}>
                          <span className="cardList__footer-count ml-1 blue-text font-weight800 cursor-pointer">
                            {kFormatter(modalData?.Followers)}
                          </span>
                        </Tooltip>
                      </div>
                    )}
                    <div
                      className={`cardList__body-description fontSize-12 pl-15 pr-15`}
                    >
                      {modalData?.PostText && (
                        <div className="text_regular break-word mb-15">
                          {!(
                            isModalReadMore?.value &&
                            isModalReadMore?.id === modalData?.TagID
                          ) && (
                            <>
                              <a
                                className={
                                  modalData?.PostURL &&
                                  modalData?.PostURL?.trim() &&
                                  modalData?.PostURL !== "NA"
                                    ? ""
                                    : "pointer-events1 cursor-default"
                                }
                                href={
                                  modalData?.PostURL &&
                                  modalData?.PostURL?.trim() &&
                                  modalData?.PostURL !== "NA"
                                    ? modalData?.PostURL
                                    : ""
                                }
                                target="_blank"
                                rel="noreferrer"
                              >
                                {modalData?.PostText || modalData?.Title}
                              </a>
                            </>
                          )}
                        </div>
                      )}

                      {modalData?.Attachment?.length === 1 ? (
                        <div className="m-0 w-100 text-center position-relative postCard_dtails--image">
                          {modalData?.Attachment?.map((imgUrl, index) => {
                            if (
                              imgUrl?.MediaType === "2" ||
                              imgUrl?.MediaType === "4"
                            ) {
                              return imgUrl ? (
                                <>
                                  <Image
                                    src={
                                      imgUrl?.ThumbUrl
                                        ? imgUrl?.ThumbUrl
                                        : defaultImg
                                    }
                                    alt="Attachment Image"
                                    style={{
                                      borderRadius: "0.6rem",
                                      objectFit: "cover",
                                      minHeight: "35rem",
                                    }}
                                    onError={onImageError}
                                    className="border w-100"
                                    fallback={defaultImg}
                                    preview={!isImage}
                                    placeholder={
                                      <Image
                                        src={placeHolderImg}
                                        preview={false}
                                        className="position_relative w-100"
                                        style={{
                                          borderRadius: "3.2rem",
                                          objectFit: "cover",
                                          height: "35rem",
                                        }}
                                      />
                                    }
                                  />
                                </>
                              ) : (
                                ""
                              );
                            } else if (
                              imgUrl?.MediaType === "3" ||
                              imgUrl?.MediaType === "7"
                            ) {
                              return imgUrl && !PdfDownloadStatus ? (
                                <>
                                  {modalData?.PlatformID === 2 ||
                                  modalData?.PlatformID === 4 ||
                                  modalData?.PlatformID === 37 ? (
                                    <a
                                      href={
                                        imgUrl?.MediaUrl ? imgUrl?.MediaUrl : ""
                                      }
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <img
                                        src={
                                          imgUrl?.ThumbUrl
                                            ? imgUrl?.ThumbUrl
                                            : defaultImg
                                        }
                                        alt="Attachment Images"
                                        style={{
                                          width: "100%",
                                          objectFit: "cover",
                                        }}
                                        onError={(modalData) =>
                                          onImageError(modalData)
                                        }
                                      />
                                      <div class="overlay-play-button__overlay">
                                        <div class="overlay-play-button__play">
                                          <i
                                            class="fa fa-play"
                                            style={{
                                              fontSize: "1.2rem",
                                              color: "#fff",
                                            }}
                                          ></i>
                                        </div>
                                      </div>
                                    </a>
                                  ) : modalData?.PlatformID === 1 ||
                                    modalData?.PlatformID === 3 ||
                                    modalData?.PlatformID === 37 ||
                                    modalData?.PlatformID === 42 ? (
                                    <>
                                      <div
                                        class="overlay-play-button"
                                        style={{ height: "25rem" }}
                                        onClick={() =>
                                          handleVideoPreview(imgUrl)
                                        }
                                      >
                                        <video
                                          width="100%"
                                          style={{
                                            objectFit: "cover",
                                            height: "25rem",
                                          }}
                                        >
                                          <source
                                            src={
                                              imgUrl?.MediaUrl
                                                ? imgUrl?.MediaUrl
                                                : defaultImg
                                            }
                                            type="video/mp4"
                                          />
                                        </video>

                                        <div class="overlay-play-button__overlay">
                                          <div class="overlay-play-button__play">
                                            <i
                                              class="fa fa-play"
                                              style={{
                                                fontSize: "1.2rem",
                                                color: "#fff",
                                              }}
                                            ></i>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    ""
                                  )}

                                  {/* For Video Preview */}
                                  <VideoPreview
                                    videoPreview={videoPreview}
                                    setIsModalOpen={setIsVideoModalOpen}
                                    isModalOpen={isVideoModalOpen}
                                    isValidUrlFlag={isValidUrlFlag}
                                  />
                                </>
                              ) : PdfDownloadStatus ? (
                                imgUrl && (
                                  <img
                                    src={imgUrl?.ThumbUrl}
                                    alt="Attachment Images"
                                    style={{
                                      width: "8rem",
                                      height: "6.6rem",
                                    }}
                                    onError={(modalData) =>
                                      onImageError(modalData)
                                    }
                                  />
                                )
                              ) : (
                                ""
                              );
                            }
                          })}
                        </div>
                      ) : (
                        modalData?.Attachment?.length > 1 && (
                          <div className="w-100">
                            <Carousel
                              el={modalData}
                              height="40.3rem"
                              postCardDetails={true}
                            />
                          </div>
                        )
                      )}
                    </div>
                    <PostCardFooter
                      data={data}
                      isPreviewState={isPreviewState}
                      PdfDownloadStatus={PdfDownloadStatus}
                      PptGeneratingStatus={PptGeneratingStatus}
                      el={modalData}
                      postDetail={false}
                    />
                  </div>
                  <div className="card-footer text-center bg__white text_regular d-flex align-items-top pt-2 pb-2 pl-15 pr-15 border-top border-color">
                    <div className="mr-15" style={{ width: "25%" }}>
                      <div className="text_regular text-grayLight white-space-nowrap">
                        Engagement
                      </div>
                      <div className="text_heading-Rubik font-size18 line-height-normal">
                        <Tooltip
                          title={modalData?.Engagement?.toLocaleString()}
                        >
                          <div className="cursor-pointer">
                            {kFormatter(modalData?.Engagement)}
                          </div>
                        </Tooltip>
                        {modalData?.PlatformID === 3 &&
                        modalData?.isPromoted === 5 ? (
                          <Tooltip
                            title={
                              "This Post Has No AD ID, So Engagement Only Includes Basic Stats Like Likes And Comments."
                            }
                          >
                            <img
                              src={InfoIconYellow}
                              style={{ maxWidth: "1.5rem" }}
                              className="mr-1 cursor-pointer"
                              alt="info"
                            />
                          </Tooltip>
                        ) : (
                          <Tooltip title={modalData?.Engagement_text}>
                            <img
                              src={fx}
                              style={{ maxWidth: "1.5rem" }}
                              className="mr-1 cursor-pointer"
                              alt="fx"
                            />
                          </Tooltip>
                        )}
                      </div>
                      {/* <Progress
                percent={modalData?.Engagement}
                showInfo={false}
                trailColor={"#c0c2c5"}
              /> */}
                    </div>
                    <div className="mr-15" style={{ width: "25%" }}>
                      <div className="text_regular text-grayLight white-space-nowrap cursor-pointer">
                        <Tooltip title="Engagement Rate">
                          <div className="white-space-nowrap">Eng. Rate</div>
                        </Tooltip>
                      </div>
                      <div className="text_heading-Rubik font-size18 line-height-normal">
                        <Tooltip
                          title={modalData?.Engagement_rate?.toLocaleString()}
                        >
                          <div className="cursor-pointer">
                            {kFormatter(modalData?.Engagement_rate)}
                          </div>
                        </Tooltip>

                        {modalData?.Engagement_rate_fx ? (
                          <Tooltip title={modalData?.Engagement_rate_text}>
                            <img
                              src={fx}
                              style={{ maxWidth: "1.5rem" }}
                              className="mr-1 cursor-pointer"
                              alt="fx"
                            />
                          </Tooltip>
                        ) : (
                          ""
                        )}
                      </div>
                      {/* <Progress
                    percent={modalData?.Engagement}
                    showInfo={false}
                    trailColor={"#c0c2c5"}
                  /> */}
                    </div>
                    <div className="mr-15" style={{ width: "25%" }}>
                      <div
                        className={`text_regular text-grayLight d-inline-flex align-items-center ${
                          modalData?.reach_fx ? "cursor-pointer" : ""
                        }`}
                      >
                        {modalData?.reach_fx ? (
                          <Tooltip title="Estimated Reach">
                            <div className="white-space-nowrap">Est. Reach</div>
                          </Tooltip>
                        ) : (
                          <div className="white-space-nowrap">Reach</div>
                        )}
                        {modalData?.reach_i && (
                          <Tooltip title="It looks like this video post has been watched by the same viewers multiple times.">
                            <img
                              src={InfoIcon}
                              alt="InfoIcon"
                              className="ml-1"
                            />
                          </Tooltip>
                        )}
                      </div>
                      <div className="text_heading-Rubik font-size18 line-height-normal">
                        <Tooltip title={modalData?.Reach?.toLocaleString()}>
                          <div className="cursor-pointer">
                            {" "}
                            {kFormatter(modalData?.Reach)}
                          </div>
                        </Tooltip>

                        {modalData?.reach_fx && (
                          <Tooltip title="Number calculated from the formula provided in account section. Updates every midnight.">
                            <img
                              src={fx}
                              style={{ maxWidth: "1.5rem" }}
                              className="mr-1 cursor-pointer"
                              alt="fx"
                            />
                          </Tooltip>
                        )}
                      </div>
                      {/* <Progress
                percent={modalData?.Reach}
                showInfo={false}
                trailColor={"#c0c2c5"}
              /> */}
                    </div>
                    <div style={{ width: "25%" }}>
                      {modalData?.impression_fx ? (
                        <Tooltip title="Estimated Impression">
                          <div className="text_regular text-grayLight white-space-nowrap cursor-pointer">
                            {" "}
                            Est. Impression
                          </div>
                        </Tooltip>
                      ) : (
                        <div className="text_regular text-grayLight white-space-nowrap">
                          Impression
                        </div>
                      )}
                      <div className="text_heading-Rubik font-size18 line-height-normal">
                        <Tooltip
                          title={modalData?.Impression?.toLocaleString()}
                        >
                          <div className="cursor-pointer">
                            {kFormatter(modalData?.Impression, false, true)}
                          </div>
                        </Tooltip>

                        {modalData?.impression_fx && (
                          <Tooltip title="Number calculated from the formula provided in account section. Updates every midnight.">
                            <img
                              src={fx}
                              style={{ maxWidth: "1.5rem" }}
                              className="mr-1 cursor-pointer"
                              alt="fx"
                            />
                          </Tooltip>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </>
        )
      ) : (
        <div
          className="portlet_images text-center pt-4 mt-15 col-12"
          style={{ minHeight: "45rem" }}
        >
          <img
            alt="no data"
            src={somethingWentWrong}
            style={{ maxWidth: "100%", minWidth: "20rem" }}
          />
          <p className="mt-15 text_regular-gray">No Data Found</p>
        </div>
      )}
    </Modal>
  );
};

export default React.memo(NetworkNodeModal, isEqual);
